import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardDonutChartComponent, DashboardDonutSize } from '../dashboard-donut-chart/dashboard-donut-chart.component';
import { DashboardTrendListComponent } from '../dashboard-trend-list/dashboard-trend-list.component';
import { EngagementDonutMetric, DashboardMetricCardLayout } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-donut-metric-card',
  standalone: true,
  imports: [IconComponent, DashboardDonutChartComponent, DashboardTrendListComponent],
  templateUrl: './dashboard-donut-metric-card.component.html',
})
export class DashboardDonutMetricCardComponent {

  @Input({ required: true })
  public metric!: EngagementDonutMetric;

  @Input()
  public layout: DashboardMetricCardLayout = 'default';

  @Input()
  public chartSize: DashboardDonutSize = 'default';

  @Input()
  public showIcon = true;

}
